import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import { uploadDocument, getUserDocuments, deleteAllDocuments, deleteDocument } from "../../../../Redux/Reducers/documentReducer.ts"
import { INITIAL_DOCUMENT_UPLOAD_STATE, DocumentUploadFormState } from "../types/document.types.ts";
// import { initiateDigilockerAPIHelper } from "../../redux/helpers/digilockerAPI";
import { buildDocumentPayload } from "../../../../services/buildDocumentPayload.ts";
import { initiateDigilockerAPIHelper } from "../../../../Redux/helpers/digilockerAPI.ts";

export const useDocument = (userId:number) => {
 const dispatch = useDispatch<any>();
  
  // Pull from Redux Store
 const { documents, loading, error } = useSelector((state: any) => state.document);
  
  // Local Form State
  const [formState, setFormState] = useState<DocumentUploadFormState>(INITIAL_DOCUMENT_UPLOAD_STATE);

  // Fetch documents on load
  useEffect(() => {
    if (userId) {
      dispatch(getUserDocuments(userId));
    }
  }, [userId, dispatch]);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setFormState(prev => ({ ...prev, file: e.target.files![0] }));
    }
  };

  const handleDocumentTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setFormState(prev => ({ ...prev, documentTypeCode: e.target.value }));
  };

//   const handleUpload = async (e: React.FormEvent) => {
//     e.preventDefault();
//     if (!userId) return toast.error("User ID is missing.");
//     if (!formState.file) return toast.warning("Please select a file to upload.");

//     try {
        
//       const formData = buildDocumentPayload(formState);
      
//       const result = await dispatch(uploadDocument({ formData, userId }));

//       if (uploadDocument.fulfilled.match(result)) {
//         toast.success("Document uploaded and processed successfully!");
//         // Reset file input but keep the selected type
//         setFormState(prev => ({ ...prev, file: null })); 
//       } else {
//         toast.error("Failed to upload document.");
//       }
//     } catch (err) {
//       toast.error("An unexpected error occurred.");
//     }
//   };



const handleUpload = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!userId) return toast.error("User ID is missing.");
    if (!formState.file) return toast.warning("Please select a file to upload.");

    try {
      const formData = buildDocumentPayload(formState);
      
      // ✨ Add .unwrap() to force Redux to throw backend errors to the catch block
      await dispatch(uploadDocument({ formData, userId })).unwrap();

      // If we reach here, it was a 100% success!
      toast.success("Document uploaded and verified successfully!");
      
      // Reset file input but keep the selected type
      setFormState(prev => ({ ...prev, file: null })); 

    } catch (err: any) {
      // ✨ THE FIX: Extract the exact text message sent by your Node.js backend
      const errorMessage = err?.response?.data?.message || "Failed to upload document.";

      // Show the beautiful red error popup with the AI's explanation
      toast.error(errorMessage, {
        position: "top-center",
        autoClose: 6000, // Keep it open a bit longer so the user can read it
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  const handleDeleteDocument = async (docId: string | number) => {
        if (window.confirm("Are you sure you want to delete this document?")) {
            await dispatch(deleteDocument({ userId, docId }));
        }
    };

    const handleDeleteAllDocuments = async () => {
        if (window.confirm("WARNING: Are you sure you want to delete ALL documents? This cannot be undone.")) {
            await dispatch(deleteAllDocuments(userId));
        }
    };

  // ==================== DIGILOCKER VERIFICATION ====================

  const initiateDigilockerVerification = async (documentId: string | number) => {
    try {
      const result = await initiateDigilockerAPIHelper(documentId);
      if (result.success && result.url) {
        // Store the code_verifier so we can use it after DigiLocker redirects back
        localStorage.setItem('digilocker_code_verifier', result.code_verifier);
        // Redirect the user to DigiLocker's authorization page
        window.location.href = result.url;
      } else {
        toast.error('Failed to initiate DigiLocker verification.');
      }
    } catch (err: any) {
      const msg = err?.message || 'Failed to initiate DigiLocker verification.';
      toast.error(msg);
    }
  };

  const initiateDigilockerVerifyAll = async () => {
    try {
      const result = await initiateDigilockerAPIHelper(); // No document_id = batch mode
      if (result.success && result.url) {
        localStorage.setItem('digilocker_code_verifier', result.code_verifier);
        window.location.href = result.url;
      } else {
        toast.error('Failed to initiate batch DigiLocker verification.');
      }
    } catch (err: any) {
      const msg = err?.message || 'Failed to initiate batch verification.';
      toast.error(msg);
    }
  };

  return {
    documents,
    isLoading: loading,
    isError: error,
    formState,
    handleFileChange,
    handleDocumentTypeChange,
    handleUpload,
    handleDeleteDocument,
    handleDeleteAllDocuments,
    initiateDigilockerVerification,
    initiateDigilockerVerifyAll,
  };
};